import React from "react";
import Box from "../../molecules/Box";
import IconButton from "../../molecules/IconButton";
import Typography from "../../molecules/Typography";
import { CloseIcon, ChevronLeftIcon, ChevronRightIcon } from "../../molecules/icons";
import { useStyles } from "./ZoomOverlay.styles";
import { ONBOARDING_TEXT } from "../../../components/text.constants";

export interface ZoomOverlayProps {
  images: string[];
  index: number;
  onClose: () => void;
  onPrev: () => void;
  onNext: () => void;
}

const ZoomOverlay = ({ images, index, onClose, onPrev, onNext }: ZoomOverlayProps) => {
  const classes = useStyles();
  const total = images.length;

  return (
    <Box className={classes.overlay} onClick={onClose}>
      <IconButton className={classes.closeBtn} onClick={(e) => { e.stopPropagation(); onClose(); }} aria-label={ONBOARDING_TEXT.ZOOM_CLOSE_ARIA}>
        <CloseIcon />
      </IconButton>

      {total > 1 && (
        <IconButton
          className={`${classes.navBtn} ${classes.navBtnLeft}`}
          onClick={(e) => { e.stopPropagation(); onPrev(); }}
          disabled={index === 0}
          aria-label={ONBOARDING_TEXT.CAROUSEL_PREV_ARIA}
        >
          <ChevronLeftIcon />
        </IconButton>
      )}

      <Box className={classes.content} onClick={(e) => e.stopPropagation()}>
        <img src={images[index]} alt={`${ONBOARDING_TEXT.PREVIEW_ALT_PREFIX} ${index + 1}`} className={classes.image} />
      </Box>

      {total > 1 && (
        <IconButton
          className={`${classes.navBtn} ${classes.navBtnRight}`}
          onClick={(e) => { e.stopPropagation(); onNext(); }}
          disabled={index === total - 1}
          aria-label={ONBOARDING_TEXT.CAROUSEL_NEXT_ARIA}
        >
          <ChevronRightIcon />
        </IconButton>
      )}

      {total > 1 && (
        <Typography className={classes.count}>{index + 1} / {total}</Typography>
      )}
    </Box>
  );
};

export default ZoomOverlay;
